import React, { useEffect, useState, useContext } from "react";
import {
  Table,
  Tag,
  Space,
  message,
  notification,
  Popconfirm,
  Button,
  Typography,
} from "antd";
import {
  BrowserRouter as Router,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { apiRoutes, environment } from "../../auth/apiRoute";
import MemberLayout from "../../layout/memberLayout";
import LoadingFrame from "../../layout/loadingFrame";
import { UserContext } from "../../auth/userContext";
export default function MyNominations(props) {
  const { Title } = Typography;
  const userContext = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(() => {
    // userContext.addPageId();
    userContext.setLoadingNewPage();
  }, []);
  useEffect(() => {
    console.log(props);

    getMyNominations();
  }, []);
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(false);
  const [nominationsData, setNominationsData] = useState([]);
  const getMyNominations = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].mynominations);
      console.log(response.data);
      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations
          .map((item) => {
            return { ...item, ...{ key: item._id } };
          })
          .sort((a, b) => {
            return parseInt(b.term) - parseInt(a.term);
          });
        setNominationsData(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const deleteNomination = async (nominationId) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].deleteNomination,
        {
          nominationId: nominationId,
        }
      );
      console.log(response.data);
      if (response.status == 200) {
        openNotification();
        getMyNominations();
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully deleted! ",
      placement: "top",
    });
  };
  const columns = [
    {
      title: "Year",
      dataIndex: "term",
      key: "term",
      filters:
        nominationsData &&
        nominationsData
          .map((item) => item.term || "no data")
          .filter((value, index, self) => self.indexOf(value) === index)
          .map((item) => {
            return { text: item, value: item };
          }),
      onFilter: (value, record) => record.term == value,
      defaultFilteredValue: [moment().year()],
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      render: (text, record) => (
        <Link to={`/member/nomination/${record._id}`}>{text}</Link>
      ),
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      render: (text, record) => (
        <Link to={`/member/nomination/${record._id}`}>{text}</Link>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Hotel",
      dataIndex: "hotel",
      key: "hotel",
      render: (text, record) => {
        return record.hotel ? (
          record.hotel.name
        ) : (
          <Tag color="warning">No Hotel</Tag>
        );
      },
    },
    {
      title: "Category",
      key: "category",
      dataIndex: "category",
      render: (text, record) => {
        const colors = ["volcano", "darkSalmon", "geekblue", "green"];
        const colorIndex = categories.findIndex((item) => item == text);

        let color = colors[colorIndex];

        return (
          <Tag color={color} key={record._id}>
            {text ?? ""}
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <Space size="middle">
            {props.isAcceptingNomination ? (
              record.term == moment().year() ? (
                <>
                  {" "}
                  <Link to={`/nomination/${record._id}/edit`}>Edit</Link>
                  <Popconfirm
                    title="Are you sure to delete this nomination?"
                    onConfirm={() => deleteNomination(record._id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <a>Delete</a>
                  </Popconfirm>
                </>
              ) : (
                <></>
              )
            ) : (
              <></>
            )}
          </Space>
        );
      },
    },
  ];
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const data = [
    {
      key: "1",

      firstName: "John",
      lastName: "Brown",
      title: 32,
      hotel: "New York No. 1 Lake Park",
      category: "Managerial Below General Manager",
    },
    {
      key: "2",
      firstName: "Jim",
      lastName: "Green",
      title: 42,
      hotel: "London No. 1 Lake Park",
      category: "Full-Time Room Attendant",
    },
    {
      key: "3",

      firstName: "Joe",
      lastName: "black",
      title: 32,
      hotel: "Sidney No. 1 Lake Park",
      category: "Full-Time Hourly With Guest Contact",
    },
  ];
  return (
    <LoadingFrame loading={loading}>
      <Title level={3}>My Nominations</Title>
      <Table
        columns={columns}
        dataSource={nominationsData}
        scroll={{ x: 500 }}
      />
      {nominationsData.length == 0 ? (
        <div style={{ textAlign: "center" }}>
          <Button>
            <Link to={"/member/nomination/add"}>Start Your Nominations</Link>
          </Button>
        </div>
      ) : (
        <></>
      )}
      <br />

      {props.user.roles.includes("judge") && (
        <div style={{ textAlign: "center" }}>
          <Button
            type="primary"
            onClick={() => {
              navigate("/judge");
              navigate(0);
            }}
          >
            Online Judge
          </Button>
        </div>
      )}
    </LoadingFrame>
  );
}
